import { Suspense } from 'react';

import { ErrorBoundary } from 'src/components/ErrorBoundary';
import { SuspenseFallback } from 'src/components/SuspenseFallback';
import { SuspenseFallbackPopup } from 'src/components/SuspenseFallbackPopup';
import { type ComponentImport, lazyWithRetry } from 'src/lib/react';

type FallbackType = 'page' | 'popup';

export const loadAsyncComponent = (
  componentImport: ComponentImport,
  fallbackType: FallbackType = 'page'
) => {
  const AsyncPage = lazyWithRetry(componentImport);

  return (props: Record<string, unknown>) => (
    <ErrorBoundary>
      <Suspense
        fallback={fallbackType === 'popup' ? <SuspenseFallbackPopup /> : <SuspenseFallback />}
      >
        <AsyncPage {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};
